var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visiable)?_c('div',{attrs:{"id":"Album"}},[_c('Carousel',{ref:"carousel",attrs:{"images":_vm.images}}),_c('guide-button',{staticClass:"btn-rt",on:{"click":_vm.close}},[_vm._v("返回")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }